import { Component } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { Insight } from 'src/app/models/insight';
import { StatisticsModel } from 'src/app/models/statistics';

@Component({
  selector: 'app-stats-insight',
  templateUrl: './stats-insight.component.html',
  styleUrls: ['./stats-insight.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule]
})
export class StatsInsightComponent extends StatisticsModel {
  public insight: Insight;

  constructor(
    public utilityService: UtilityService,
    protected ref: NbDialogRef<StatsInsightComponent>
  ) {
    super();
  }

  /**************************************************************/

  public getAverageExecDuration(): string | boolean {
    return super.getAverageExecDuration(this.insight.total_duration, this.insight.executions);
  }

  /**************************************************************/

  public getAveragePublishes(): number {
    return super.getAverageValue(this.insight.total_results, this.insight.executions);
  }

  /**************************************************************
   * Used in HTML
   *************************************************************/
  public convertUnixTime(epoch: number): string | boolean {
    return this.utilityService.convertUnixTime_global(epoch);
  }

  public close() {
    this.ref.close();
  }
}
